<div class="xcdrs-dialog">
    <div mat-dialog-title>
        <section class="tw-flex tw-flex-col tw-justify-center md:tw-mb-12 tw-mb-8 tw-w-full max-md:max-w-full">
            <div class="tw-flex tw-flex-col tw-justify-center tw-w-full tw-text-center max-md:max-w-full">
                <h2 class="tw-self-center !md:tw-text-2xl !tw-text-xl !tw-font-bold !tw-leading-none tw-text-gray-900">
                    {{'JoinGroupDialog.SelectSubgroup' | translate}}
                </h2>
                <div
                    class="tw-mt-3 !tw-mx-2 !md:tw-mx-0 !md:tw-text-base !tw-text-sm tw-text-gray-500 max-md:max-w-full">

                    {{'JoinGroupDialog.ChooseSubgroupToJoin' | translate}}
                </div>
            </div>
        </section>
    </div>
    <div mat-dialog-content
        class="mat-dialog-content !tw-m-0 !md:tw-mb-12 !tw-mb-8 tw-overflow-y-auto scroll-hide hover:tw-overflow-y-auto">

        <article class="tw-flex tw-flex-col tw-gap-2.5 tw-items-start tw-w-full tw-bg-white">
            <section *ngFor="let subGroup of subGroups; let i = index"
                class="tw-flex tw-flex-col tw-gap-7 tw-items-start tw-px-0 tw-py-7 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-border-solid max-md:tw-px-0 max-md:tw-py-6 max-sm:tw-px-0 max-sm:tw-py-5 max-sm:tw-border max-sm:tw-border-white max-sm:tw-border-none">
                <header
                    class="tw-flex tw-justify-between tw-items-center tw-px-8 tw-py-0 tw-w-full max-md:tw-px-6 max-md:tw-py-0 max-sm:tw-flex-row max-sm:tw-gap-4 max-sm:tw-justify-center max-sm:tw-items-center max-sm:tw-px-4 max-sm:tw-py-0 max-sm:tw-mr-auto">
                    <div class="tw-flex tw-gap-4 tw-items-center max-sm:tw-w-full">
                        <div class="tw-relative tw-w-7 tw-h-7">
                            <div class="tw-w-7 tw-h-7 tw-text-lg tw-font-bold tw-leading-7 tw-text-white tw-rounded-lg tw-flex tw-items-center tw-justify-center"
                                [ngStyle]="{
                                        'background-image': 'url(assets/images/business-units/business_unit_bg_' + ((i % 12) + 1) + '.svg)',
                                        'background-size': 'cover',
                                        'background-repeat': 'no-repeat',
                                        'background-position': 'center'
                                    }">
                                {{subGroup?.GroupName?.charAt(0) || ''}}
                            </div>
                        </div>
                        <div class="tw-flex tw-flex-col tw-gap-[0.25rem]">
                            <span
                                class="tw-text-xl tw-font-bold tw-leading-7 tw-text-gray-900">{{subGroup?.GroupName}}</span>
                            <span
                                class="tw-font-normal tw-text-[0.875rem] tw-leading-[1.25rem] tw-text-[#667085]">{{('JoinGroup.'
                                + subGroup?.GroupMembershipOption) | translate}}</span>
                        </div>
                    </div>
                    <div>
                        <span (click)="onSubGroupSelect(subGroup)" class="join" *ngIf="!subGroup.isJoined; else joined">
                            <span [translate]="'JoinGroup.Join'"></span>
                        </span>
                        <ng-template #joined>
                            <span class="joined">{{'JoinGroupDialog.Joined' | translate}}</span>
                        </ng-template>
                        <span class="join d-none"></span>
                    </div>
                </header>
            </section>
        </article>
    </div>
    <div mat-dialog-actions>
        <div class="tw-flex tw-flex-row tw-w-full">
            <button *ngIf="!groupJoined" (click)="onCancel()" class="!tw-text-[#101828] tw-w-full !tw-h-[3.75rem]"
                mat-stroked-button color="primary">
                <span [translate]="'JoinGroupDialog.Skip'"></span>
            </button>

            <button *ngIf="groupJoined" (click)="onDone()" class="tw-w-full !tw-h-[3.75rem] !tw-text-[#101828]"
                mat-stroked-button color="primary">
                <span [translate]="'Done'"></span>
            </button>

        </div>
    </div>
</div>

<div *ngIf="isLoading" fxFlex fxLayout="column" fxLayoutAlign="space-around center" class="spinner-container">
    <mat-spinner></mat-spinner>
</div>